import React, {useState, useEffect} from 'react';
import { useHistory, useLocation } from "react-router-dom"
import createPersistedState from 'use-persisted-state';
import jwtDecode from 'jwt-decode';
import useQueryParams from '../hooks/useQuery'
import AccountRedirect from '../pages/AccountRedirect';
import Logo from '../images/logo/logo.svg';
import SamsungLogo from '../images/logo/samsung.svg'
import OtmscLogo from '../images/logo/otmsc.png'
import OficinaIbsLogo from '../images/logo/oficinasibs.png'
import FinanzasBCLogo from '../images/logo/finanzasbc.png'
import CompusolucionesLogo from '../images/logo/compusoluciones.png'
import SibareLogo from '../images/logo/sibare.png'
import CeticLogo from '../images/logo/celtic.png'
import TecnoCasaLogo from '../images/logo/tecnocasa.png'
import RemaxLogo from '../images/logo/remax.png'
import OysterLogo from '../images/logo/oyster.png'


const ThemeStateContext = React.createContext();
const ThemeDispatchContext = React.createContext();
const useThemePersistedState = createPersistedState('theme');

function getAppLogo(partnerId) {
  switch(partnerId) {
    case 'cetic':
      return{ logo: CeticLogo, logoClassName: 'navbar-logo-width-xs', partnerName: 'CETIC', domain: 'cetic'  }; 
    case 'sibare':
      return{ logo: SibareLogo, partnerName: 'SIBARE', domain: 'sibare'  }; 
    case 'partners':
      return{ logo: Logo, partnerName: 'Partner Demo', domain: 'partners'  }; 
    case 'compusoluciones':
      return{ logo: CompusolucionesLogo, partnerName: 'Compusoluciones', domain: 'compusoluciones_partner'  }; 
    case 'oficinasibs':
      return{ logo: OficinaIbsLogo, partnerName: 'Oficinas IBS', domain: 'oficinasibs'  }; 
    case 'finanzasbc':
      return{ logo: FinanzasBCLogo, partnerName: 'Finanzas BC', domain: 'finanzasbc'  }; 
    case 'samsung':
      return{ logo: SamsungLogo, partnerName: 'Samsung', domain: 'samsung'  }; 
    case 'otmsc':
      return{ logo: OtmscLogo, partnerName: 'OTMSC', domain: 'otmsc'  };
    case 'tecnocasa':
      return{ logo: TecnoCasaLogo, partnerName: 'Tecnoasa', domain: 'tecnocasa'  };
    case 'remax':
      return{ logo: RemaxLogo, partnerName: 'REMAX', domain: 'remax'  };
    case 'oyster':
      return{ logo: OysterLogo, partnerName: 'Oyster', domain: 'oyster'  };
    case 'starter': 
    default:
      return { logo: Logo };;
  }
}


function ThemeProvider({children}) {
  const location = useHistory(); 
  const [theme, setTheme] = useThemePersistedState({});
  const { hostname } = window.location;

  useEffect(() => {
      const [ partnerId ] = hostname.split('.');
      const { logoClassName, logo, partnerName = '', domain } = getAppLogo(partnerId)
      const currentDomain =  domain ?? (partnerId ?? 'starter');
      setTheme(theme => ({
        ...theme,
        appLogo: logo,
        logoClassName,
        isPartner: !['starter', 'freemium', 'lawyers'].includes(currentDomain),
        partnerName,
        domain: currentDomain
      }))
  }, [hostname, setTheme])

  return (
    <ThemeStateContext.Provider value={theme}>
      <ThemeDispatchContext.Provider value={setTheme}>
        {children}
      </ThemeDispatchContext.Provider>
    </ThemeStateContext.Provider>
  )
}

function useThemeState() {
  const context = React.useContext(ThemeStateContext)
  if (context === undefined) {
    throw new Error('useThemeState must be used within a ThemeProvider')
  }
  return context
}

function useThemeDispatch() {
  const context = React.useContext(ThemeDispatchContext)
  if (context === undefined) {
    throw new Error('useThemeDispatch must be used within a ThemeProvider')
  }
  return context
}

function useTheme() {
  return [useThemeState(), useThemeDispatch()]
}

export { ThemeProvider, useTheme, useThemeState, useThemeDispatch }